import styled from 'styled-components';

export const ContainerWrapper = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;

  height: 100%;
  width: 100%;
  z-index: 1000;

  background: transparent;
`;

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;

  width: 20rem;
  height: 100%;

  z-index: 999;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  color: var(--white);
  background-color: var(--primary_color);
  padding: 3rem;
  gap: 1.4rem;
  font-size: 0.9rem;
  overflow-y: scroll;

  ::-webkit-scrollbar-track {
    background-color: transparent;
  }
  scroll-margin-left: 1rem;
  scrollbar-track-color: transparent;
  ::-webkit-scrollbar {
    width: 0.4rem;
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: var(--white);
    border-radius: 1rem;
  }

  scrollbar-base-color: var(--white);

  @keyframes transformEntryAnimationMenuMobile {
    from {
      transform: translateX(-100%);
    }
    to {
      transform: translateX(0);
    }
  }

  @keyframes transformExitAnimationMenuMobile {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(-100%);
    }
  }

  animation: transformEntryAnimationMenuMobile 0.3s;

  &.closing {
    animation: transformExitAnimationMenuMobile 0.3s;
  }

  .header-close {
    position: relative;
    width: 100%;

    .close-icon {
      cursor: pointer;
      position: absolute;
      top: 0;
      right: 0;
    }
  }

  .header-nav-user {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.4rem;
    cursor: pointer;
  }

  .sign-out {
    cursor: pointer;
  }

  .group-ultra-brands {
    strong {
      font-size: 1.1rem;
    }

    > div {
      display: flex;
      align-items: center;
      flex-direction: column;
      gap: 1rem;
      margin-top: 1rem;

      a {
        display: flex;
        justify-content: center;
        width: 100%;

        .ultrafarma {
          max-width: 8rem;
        }
      }

      a + a {
        border-top: 0.01rem solid var(--white);
        padding-top: 0.4rem;
      }
    }
  }
`;
